module.exports = __webpack_public_path__ + "images/store_case_study/korindo-pic1_dad4500a540eb7418c57c45a57cac2de.jpg";